import { useState } from 'react';
import styled from 'styled-components';
import { uploadImage } from '../services/cloudinary';

const Wrapper = styled.div`
  padding: 20px;
  margin-top: 100px;
`;

const FileInput = styled.input`
  padding: 10px 16px;
  border: 1px solid #ccc;
  border-radius: 6px;
  cursor: pointer;
`;

function TestUpload() {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = async (e) => {
    try {
      setLoading(true);
      const file = e.target.files[0];

      const url = await uploadImage(file);
      console.log('✅ Imagen subida:', url);

      setImageUrl(url);
    } catch (err) {
      console.error('❌ Error:', err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Wrapper>
      <h2>Test Cloudinary</h2>

      <FileInput type="file" onChange={handleChange} />

      {loading && <p>Subiendo imagen...</p>}

      {imageUrl && (
        <div>
          <p>Imagen subida:</p>
          <img
            src={imageUrl}
            alt="Preview"
            style={{ width: 300, marginTop: 10 }}
          />
        </div>
      )}
    </Wrapper>
  );
}

export default TestUpload;